<template>
    <div>
        <!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'线索管理'}]" />-->
        <Breadtabsheader/>
        <!-- 实时招标搜素条件 -->
        <div class="h-piece">
            <div class="h-formBox">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">

                        <el-form-item label="战区" prop="areaName">
                            <brselect :dictNameAsValues=true category="show_area" :v="q.bigArea" v-model="q.bigArea"
                                      :clearable="true"
                                      style="width:100%"/>
                        </el-form-item>
                        <el-form-item label="省区" prop="orderProvince">
                            <el-select v-model="q.orderProvince" filterable clearable style="width: 80%;">
                                <el-option
                                    v-for="item in shenglist"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="线上矩阵状态" prop="trackStatus">
                            <brselectlazy category="track_status_matrix" :v="q.trackStatus" v-model="q.trackStatus"
                                          :clearable="true"
                                          style="width:100%"/>
                        </el-form-item>

                        <el-form-item label="渠道名称" prop="channelName">
                            <brselect :dictNameAsValues=true category="clue_channel_zb" :v="q.channelName" v-model="q.channelName"
                                      :clearable="true"
                                      style="width:100%"/>
                        </el-form-item>


                    </div>
                    <el-collapse-transition>
                        <div v-show="isScreen">
                            <div class="h-thirdColumn w-newColumn">

                                <el-form-item label="订单编码" prop="orderCode">
                                    <el-input v-model="q.orderCode" placeholder="请输入"></el-input>
                                </el-form-item>

                                <el-form-item label="创建日期" class="timeselect" style="width: 50%;">
                                    <el-date-picker
                                        placeholder="请选择"
                                        v-model="q.startDate"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                    <span class="w-time-to">至</span>
                                    <el-date-picker
                                        placeholder="请选择"
                                        v-model="q.endDate"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </div>

                        </div>
                    </el-collapse-transition>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
                    </div>
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                        <el-button  class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
                            新增线上矩阵
                        </el-button>
                    </div>
                </div>
            </div>
        </div>


        <!-- 新营销结果展示 -->
        <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">

            <el-table
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                :data="tableData"
                :border="true"
                max-height="560"
                style="width: 100%"
            >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="序号"
                    type="index"
                    width="50px">
                </el-table-column>

                <el-table-column prop="companyCode" label="托盘商编码" width="100px"></el-table-column>
                <el-table-column prop="companyName" label="托盘商名称" width="140px"></el-table-column>
                <el-table-column prop="orderType" label="订单类型" width="100px"></el-table-column>
                <el-table-column prop="orderCode" label="订单编码" width="120px"></el-table-column>
                <el-table-column prop="platformName" label="电商平台名称" width="100px"></el-table-column>

                <el-table-column prop="bigArea" label="战区" width="100px"></el-table-column>
                <el-table-column prop="orderProvince" label="订单所在省" width="100px"></el-table-column>
                <el-table-column prop="orderCity" label="订单所在市" width="80px"></el-table-column>
                <el-table-column prop="address" label="详细地址" :show-overflow-tooltip="true" width="120px"></el-table-column>
                <el-table-column prop="channelName" label="渠道名称" width="100px"></el-table-column>

                <el-table-column prop="userUnitName" label="用户单位" :show-overflow-tooltip="true" width="180px"></el-table-column>
                <el-table-column prop="trackStatus" label="线上矩阵状态" width="100px">
                    <template slot-scope="scope">
                        <dictname category="track_status_matrix" :v="scope.row.trackStatus"></dictname>
                    </template>
                </el-table-column>
                <el-table-column prop="undertakePersonCode" label="承接经销商编码" width="130px"></el-table-column>
                <el-table-column prop="undertakePersonName" label="承接经销商名称" width="130px"></el-table-column>

<!--                <el-table-column prop="taskType" label="任务类型" width="100px">
                    <template slot-scope="scope">
                        <dictname category="zb_task_type" :v="scope.row.taskType"></dictname>
                    </template>
                </el-table-column>-->
                <el-table-column prop="cdate" label="创建时间" width="150px"></el-table-column>
                <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true" width="120px"></el-table-column>
                <el-table-column
                    label="操作"
                    fixed="right"
                    width="300"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.id" class="table-action-btns" style="text-align: left;">
                            <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="viewDetail(scope.row)">
                                查看
                            </el-button>
                            <el-button
                                v-if="(scope.row.trackStatus == '0') && isTodoPerson(scope.row) && (scope.row.taskType != 1 && scope.row.taskType!=9 && scope.row.taskType!=11)"
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="undertakeOpen(scope.row)"
                            >承接
                            </el-button>
                            <!--上传凭证后二次确认 -->
                            <el-button
                                v-if="(scope.row.trackStatus == '2') && _user.usercode ==  scope.row.todoPersonCode"
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="undertakeOpen(scope.row)"
                            >二次确认
                            </el-button>

                            <!-- 只有托盘商能上传付款凭证 -->
                            <el-button
                                v-if=" _user.usercode ==  scope.row.companyCode &&  (scope.row.orderType=='咨询订单' && scope.row.taskType == 9 ) "
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="uploadPaymentVoucher(scope.row)"
                            >上传付款凭证
                            </el-button>
                            <!-- 承接人能填写回传单号 -->
                            <el-button
                                v-if=" _user.usercode ==  scope.row.undertakePersonCode &&
                                 ((scope.row.orderType=='咨询订单' && scope.row.taskType == 13) || (scope.row.orderType=='正常订单' &&( scope.row.taskType == 9 || scope.row.taskType == 13))) "
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="backWlNo(scope.row)"
                            >回传单号
                            </el-button>


                            <el-button
                                v-if=" _user.usercode ==  scope.row.todoPersonCode && scope.row.state == 0 && (scope.row.taskType == 1 ) "
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="designate(scope.row)"
                            >确认指派
                            </el-button>



                            <!-- 销售人员为当前登录人，并且没有承接的 且不等于员工待指派  -->
                            <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="selectcluedetails(scope.row)">
                                跟踪日志
                            </el-button>

                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>



         <!--追踪详情弹出框-->
        <el-dialog :close-on-click-modal="false"  @close='closeCluedetails' :visible.sync="cluedetailsDialog" class="h-dialog6">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>线索日志</h1>
                    </div>
                </div>
            </div>
            <div style="padding-top: 12px;">
                <template>
                    <el-table :data="cluetracktable" border style="width: 100%">
                        <el-table-column label="序号" type="index" width="50"></el-table-column>
                        <el-table-column prop="pushDate" :show-overflow-tooltip="true" label="分发时间" width="150"></el-table-column>
                        <el-table-column prop="pushUserCode" :show-overflow-tooltip="true" label="接收人编码" width="120" >  </el-table-column>
                        <el-table-column prop="pushUserName" :show-overflow-tooltip="true" label="接收人姓名" width="120" >  </el-table-column>
                        <el-table-column prop="pushNode" label="线索节点" width="100px">
                            <template slot-scope="scope">
                                <dictname category="matrix_push_node" :v="scope.row.pushNode"></dictname>
                            </template>
                        </el-table-column>
                        <el-table-column prop="isTimeOut" :show-overflow-tooltip="true" label="处理状态" width="100">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isTimeout == 1">已超时</span>
                                <span v-if="scope.row.isTimeout == 0">已处理未超时</span>
                                <span v-if="scope.row.isTimeout == 2">待处理</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pushRole" :show-overflow-tooltip="true" label="接收人角色" width="100"></el-table-column>
                        <el-table-column prop="createRole" :show-overflow-tooltip="true" label="操作人角色" width="100"></el-table-column>
                        <el-table-column prop="operaterType" :show-overflow-tooltip="true" label="操作方式" width="100"></el-table-column>
                        <el-table-column prop="carryDate" label="处理时间" width="150"></el-table-column>
                        <el-table-column prop="cuname" label="操作人" width="100"></el-table-column>
                    </el-table>
                </template>
            </div>
        </el-dialog>


        <!--上传付款凭证弹出框-->
        <el-dialog :close-on-click-modal="false" :visible.sync="uploadVoucherDialog" class="h-dialog2" @close="closeUploadVoucher">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>上传付款凭证</h1>
                    </div>
                </div>
            </div>
            <div style="padding: 20px;">
                <brupload
                    ref="voucherUpload"
                    v-if="currentVoucherRow"
                    :refid="currentVoucherRow.id"
                    reftype="线上矩阵-付款凭证"
                    :showtime="false"
                    :uploadflag="!currentVoucherRow.voucherUploadTime"
                    :delflag="!currentVoucherRow.voucherUploadTime"
                    >
                </brupload>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="uploadVoucherDialog = false">取 消</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="confirmUploadVoucher">确 定</el-button>
            </div>
        </el-dialog>

        <!--回传单号弹出框-->
        <el-dialog :close-on-click-modal="false" :visible.sync="uploadwlDialog" class="h-dialog2" @close="closeWlDialog">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>回传物流揽收单号</h1>
                    </div>
                </div>
            </div>
            <div class="h-dialogForm">
                <el-form :model="wlForm" ref="wlForm" :rules="wlRules" :inline="true" label-position="right" class="demo-ruleForm">
                    <el-form-item label="物流类型" prop="wuliufangshi" class="h-elformWrap-1">
                        <el-radio-group v-model="wlForm.wuliufangshi" @change="handleWlTypeChange">
                            <el-radio label="快递物流">快递物流</el-radio>
                            <el-radio label="自己运输">自己运输</el-radio>
                            <el-radio label="网点配送">网点配送</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <!-- 快递物流 -->
                    <template v-if="wlForm.wuliufangshi == '快递物流'">
                        <el-form-item label="快递公司" class="h-elformWrap-1" prop="kuaidiCompany" >
                            <brselect :dictNameAsValues=true category="kuaidi_company" :v="wlForm.kuaidiCompany" v-model="wlForm.kuaidiCompany"
                                      clearable
                                      @change="handleKuaidiCompanyChange"
                                      style="width:100%"/>
                        </el-form-item>
                        <el-form-item label="快递单号" prop="kuaidiNumber" class="h-elformWrap-1">
                            <el-input v-model="wlForm.kuaidiNumber" placeholder="请输入快递单号" clearable></el-input>
                        </el-form-item>
                    </template>

                    <!-- 自己运输 / 网点配送 -->
                    <template v-if="wlForm.wuliufangshi == '自己运输' || wlForm.wuliufangshi == '网点配送'">
                        <el-form-item label="送货车牌号" prop="carNumber" class="h-elformWrap-1">
                            <el-input v-model="wlForm.carNumber" placeholder="请输入送货车牌号" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="司机姓名" prop="driverName" class="h-elformWrap-1">
                            <el-input v-model="wlForm.driverName" placeholder="请输入司机姓名" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="司机电话" prop="driverPhone" class="h-elformWrap-1">
                            <el-input v-model="wlForm.driverPhone" placeholder="请输入司机电话" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="驾驶证编号" prop="driverLicenseNumber" class="h-elformWrap-1">
                            <el-input v-model="wlForm.driverLicenseNumber" placeholder="请输入驾驶证编号" clearable></el-input>
                        </el-form-item>
                    </template>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="uploadwlDialog = false">取 消</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitWlForm">确 定</el-button>
            </div>
        </el-dialog>


        <div class="h-tableB h-mrt30">
            <div class="h-tableBL" style="margin-left: 23px">

                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                           @click="exportExcel">导出
                </el-button>

            </div>
            <div class="h-pagination2">
                <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
            </div>
        </div>

    </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moment from "moment";
import BscClueOnlineMatrix from "@/api/guanhuai/onlineMatrix/BscClueOnlineMatrix";
import uploaddown from "@/utils/updownfile";

export default {
    components: {
        uploaddownexcel
    },

    props: {
        fromSourceList: {
            type: Array,
        },
        fromSourceType: {
            type: String,
        }
    },

    data() {
        return {
            // 展开折叠筛选
            isScreen: false,
            closeScreen: require("@/assets/images/pimg/closeallic.png"),
            drawScreen: require("@/assets/images/pimg/dobleArr.png"),
            q: {
                orderProvince: '',
                bigArea:'',
                userUnitName: '',
                channelName: '',
                channelCode: '',
                trackStatus: '',
                startDate: '',
                endDate: '',
                orderCode: '',
                pageSize: 10,
                pageNo: 1,
                total: 0,
            },
            tableData: [],
            add: {
                companyName: '',
                companyCode: '',
                operatorTelephone: '',//联系人电话
                platformName: '',//电商平台名称
                orderType: '',
                bigArea: '',
                orderProvince: '',
                orderCity: '',
                address: '',
                userUnitName: '',
                remark: '',
            },
            detailList: [
                { productCode: '', productModel: '', amount: 0, industry: 0 }
            ],


            //线索跟踪详情
            cluetracktable: [],

            shenglist: [],      //省份list

            cluedetailsDialog: false,//线索日志
            undertakeDialog: false,  //承接对话框
            newDialog:false, //新增弹出窗
            usercode: '',

            uploadVoucherDialog: false,
            voucherFileList: [],
            currentVoucherRow: null,

            //物流dialog
            uploadwlDialog: false,
            currentWlRow: null,
            wlForm: {
                id: '',
                wuliufangshi: '',
                kuaidiCompany: '',
                kuaidiCompanyCode: '',
                kuaidiNumber: '',
                carNumber: '',
                driverName: '',
                driverPhone: '',
                driverLicenseNumber: '',
            },
            wlRules: {
                wuliufangshi: [{ required: true, message: '请选择物流类型', trigger: 'change' }],
                kuaidiCompany: [{ required: true, message: '请输入快递公司', trigger: 'blur' }],
                kuaidiNumber: [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
                carNumber: [{ required: true, message: '请输入送货车牌号', trigger: 'blur' }],
                driverName: [{ required: true, message: '请输入司机姓名', trigger: 'blur' }],
                driverPhone: [{ required: true, message: '请输入司机电话', trigger: 'blur' }],
                driverLicenseNumber: [{ required: true, message: '请输入驾驶证编号', trigger: 'blur' }],
            },
        }
    },
    methods: {
        //当前登录人是否为承接经销商（多个编码用逗号分隔）
        isTodoPerson(row) {
            return (row.todoPersonCode || '').split(',').map(item => item.trim()).includes(this._user.usercode);
        },


        //明细导出
        exportExcel() {
            updownfile.down("/api/swyl/v1/demo/bscClueOnlineMatrix/downloadExcel", this.q, "get", 'data');
        },


        query() {
            this.selectPageAll()
        },


        undertakeOpen(data){
            this.$router.push({
                path: '/designateOnlineMatrix',
                query: {id: data.id}
            })
        },

        //上传付款凭证弹窗
        uploadPaymentVoucher(row) {
            this.currentVoucherRow = row;
            this.uploadVoucherDialog = true;
        },

        //回传单号弹窗
        backWlNo(row) {
            this.currentWlRow = row;
            this.wlForm = {
                id: row.id,
                wuliufangshi: row.wuliufangshi || '',
                kuaidiCompany: row.kuaidiCompany || '',
                kuaidiCompanyCode: row.kuaidiCompanyCode || '',
                kuaidiNumber: row.kuaidiNumber || '',
                carNumber: row.carNumber || '',
                driverName: row.driverName || '',
                driverPhone: row.driverPhone || '',
                driverLicenseNumber: row.driverLicenseNumber || '',
            };
            this.uploadwlDialog  = true;

        },
        //物流类型切换，清空无关字段
        handleWlTypeChange(val) {
            if (val == '1') {
                this.wlForm.carNumber = '';
                this.wlForm.driverName = '';
                this.wlForm.driverPhone = '';
                this.wlForm.driverLicenseNumber = '';
            } else {
                this.wlForm.kuaidiCompany = '';
                this.wlForm.kuaidiCompanyCode = '';
                this.wlForm.kuaidiNumber = '';
            }
            this.$nextTick(() => {
                this.$refs.wlForm && this.$refs.wlForm.clearValidate();
            });
        },
        //选择快递公司联动赋值编码
        handleKuaidiCompanyChange(obj) {
            this.wlForm.kuaidiCompanyCode = obj ? obj.code : '';
        },
        //提交回传物流信息
        submitWlForm() {
            this.$refs.wlForm.validate(valid => {
                if (valid) {
                    BscClueOnlineMatrix.saveWlInfo(this.wlForm).then(rd => {
                        this.$message.success("回传单号保存成功");
                        this.uploadwlDialog = false;
                        this.query();
                    });
                }
            });
        },
        //关闭回传单号弹窗
        closeWlDialog() {
            this.uploadwlDialog = false;
            this.currentWlRow = null;
        },

        confirmUploadVoucher() {
            const fileList = this.$refs.voucherUpload ? this.$refs.voucherUpload.fileList : [];
            if (fileList.length > 0) {
                ss.BscClueOnlineMatrix.uploadPaymentVoucher({id: this.currentVoucherRow.id}).then(rd => {
                    if (rd.f) {
                        this.$message.success("付款凭证上传成功");
                        this.uploadVoucherDialog = false;
                        this.query();
                    } else {
                        // 业务异常，删除已上传的附件
                        fileList.forEach(file => uploaddown.deleteById(file.id));
                    }
                }).catch(() => {
                    fileList.forEach(file => uploaddown.deleteById(file.id));
                    this.$message.error("上传异常，已删除附件");
                });
            } else {
                this.$message.warning("请先上传付款凭证");
            }
        },

        closeUploadVoucher() {
            this.uploadVoucherDialog = false;
            this.currentVoucherRow = null;
        },



        selectPageAll() {
            ss.BscClueOnlineMatrix.selectPage(this.q).then(rd => {
                this.tableData = rd.records;
                this.q.total = rd.total;
            })
        },


        //checkbook  获取多选框元素
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        //指派
        designate(data) {
            this.$router.push({
                path: '/designateOnlineMatrix',
                query: {id: data.id}
            })
        },



        // 展开折叠
        collapseChange() {
            this.isScreen = !this.isScreen;
        },

        //新增销售样表
        create() {
            this.$router.push({path: "/bscClueOnlineMatrixAdd"});
        },
        //查看
        viewDetail(row) {
            this.$router.push({path: "/bscClueOnlineMatrixAdd", query: {id: row.id, viewMode: 1}});
        },
        rest() {
            this.q.areaName = '',
                this.q.userUnitName = '',
                this.q.chainGroup = '',
                this.q.proCategory = '',
                this.q.channelName = '',
                this.q.clueFrom = '',
                this.q.trackStatus = '',
                this.q.state = '',
                this.q.funnelCode = '',
                this.q.startDate = '',
                this.q.endDate = '',
                this.q.incomingCall = '',
                this.q.telephone = ''
            // pageSize: 10,
            // pageNo: 1,
            // total: 0,
        },


        loadArea(i) {
            let proSelect = {
                pcode: 0,
                level: 1,
            }
            console.log(proSelect)
            ss.Dictservice.arealist(proSelect).then(rd => {
                this.shenglist = rd;
            })
        },


        handleItemChange2(o) {
            this.add.city = o;
        },




        //查看流转日志
        selectcluedetails(row){
            var data ={
                "mainId":row.id
            }
            //根据id查询线索跟踪
            ss.BscClueZhaoBiao.selectCluePushLog(data).then(res =>{
                this.cluetracktable = res.records;

            })
            this.cluedetailsDialog = true
        },

        /**
         * 转项目
         * */
        toProject(row){
            this.$router.push({
                path: "/clueToProject",
                query: {id: row.id}
            })
        },
        updateDetailxs(id){
            if(!id){
                this.$msg.msge("无关联id!");
                return ;
            }
            var path = '/infoIndex';
            let routeData = this.$router.resolve({path: path, query: {'id':id}});
            window.open(routeData.href, '_blank');
        },

        mounted() {
            this.selectPageAll();
        },

        //关闭承接表单
        undertakeClose(){
            this.undertakeDialog = false
            this.f ={};
        },
        //关闭线索跟踪详情
        closeCluedetails(){
            this.cluedetailsDialog = false;

            this.cluetracktable = [];
        },

        /**新增**/
        closeTuopanDialog(){
            this.newDialog = false;
        },
        addDetailRow() {
            this.detailList.push( { productCode: '', productModel: '', amount: 0, industry: 0 });
        },
        removeDetailRow(index) {
            if (this.detailList.length > 1) {
                this.detailList.splice(index, 1);
            } else {
                this.$message.warning('至少保留一行');
            }
        },



        // 通过销售人员名称去查询
        showInfo(event) {
            for (var i = 0; i < this.allsaleman.length; i++) {
                var ishave = false;
                for (var j = 0; j < this.salesmanList.length; j++) {
                    /****
                     * 1、判断this.salesmanList[j] 是否为空
                     * 2、判断下拉集合数据的销售人员名称和总集合销售人员名称是否一致
                     * 3、判断下拉集合数据的销售人员名称和页面输入名称是否一致
                     *
                     **/
                    if (this.salesmanList[j]
                        && this.salesmanList[j].userName == this.allsaleman[i].userName
                        && this.salesmanList[j].userName == event.target.value) {
                        //去判断下拉集合数据的销售人员工号是否已经存在
                        if (this.salesmanList[j].userCode == this.allsaleman[i].userCode) {
                            ishave = true;
                            break;
                        }
                    }
                }
                if (!ishave && event.target.value == this.allsaleman[i].userName) {
                    this.salesmanList.push(this.allsaleman[i]);
                }
            }
        },


        //地址选择器-新
        handleItemChangeN(o) {
            this.address = _.find(this.shenglist, {code: this.add.provinceId});
            // this.add.province = this.address.name;
            ss.Dictservice.areaTreelist({code: o}).then(rd => {
                this.arealist2 = rd.zlist;
                this.arealist3 = [];
                this.address = _.find(this.arealist2, {code: this.add.cityId});
                // this.add.city = this.address.name;
                this.arealist3 = _.find(this.arealist2, {code: o}).zlist
            })
        },

        isUrl(str) {
            return typeof str === 'string' && (str.startsWith('http://') || str.startsWith('https://'));

        },
        openUrl(url){
            window.open(url, '_blank');
        }

    },
    watch: {
        'add.customerName': {
            deep: true,
            handler: function (newVal, oldVal) {
                this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
                var len = this.groupList.length;//groupList
                var arr = [];
                for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
                    if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
                        arr.push({
                            value: this.groupList[i].name,
                            id: this.groupList[i].id
                        })
                    }
                }
                this.groupArr = arr
            }
        },
    },
    created() {

        console.log('fromSourceType:', this.fromSourceType);

        //是否管理员权限
        this.adminFlag = this.$store.getters.hasRole('swyl_admin');

        this.usercode = this._user.usercode;
        this.query();
        this.loadArea();
    },

}
</script>
<style scoped>
.table-action-btns .h-btn.el-button.h-tableLink {
    padding: 0 0.02rem;
}
.table-action-btns .h-btn.el-button + .h-btn.el-button {
    margin-left: 0.03rem;
}
/deep/ .h-formbLine .el-form-item__label {
    width: 110px;
}

/deep/ .h-formbLine .el-form-item__content {
    width: 150px;
}

/*/deep/ .h-elformWrap-1 .el-form-item__content{*/
/*    width: 78%;*/
/*}*/
/deep/ .h-elformWrap-1 .el-form-item__content {
    width: 78%;
}

.addPro {
    width: 100%;
    /* display:flex; */
}

.addPro .el-form-item {
    width: 45% !important;
}

.addPro .el-form-item /deep/ .el-form-item__content {
    width: 115px;
}

/*设置父级样式*/
.vue-treeselect >>> .vue-treeselect__control {
    width: 150px;
}

.el-switch {
    margin: auto auto auto 20px;
}
.invalid-reason-dialog /deep/ .el-dialog {
    width: 500px !important;
}
/*.projectCon p{*/
/*  justify-content: space-between;*/
/*  align-items:center;*/
/*  font-size: 14px;*/
/*  border-bottom:#1b78e6 1px dashed;*/
/*  padding: 5px 0;*/
/*  margin: 0 auto 10px auto;*/
/*  color: #1b78e6;*/
/*}*/
</style>
